import { IBackendDataPrice } from "src/@types";
import { globalVars } from "src/data/globals";

export const backendDataPriceHandler = (eventObj: IBackendDataPrice) => {
  const { price } = eventObj;
  globalVars.backendDataPrice = price;
  // console.log("price::", price);
};

